import { Component, Input, OnInit, ViewEncapsulation } from "@angular/core";
import { Router } from "@angular/router";
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from "@angular/animations";

import { MenuDTO } from "src/app/models/Menu/MenuDTO";

@Component({
  selector: "app-menu-list",
  templateUrl: "./menu-list.component.html",
  styleUrls: ["./menu-list.component.scss"],
  encapsulation: ViewEncapsulation.None,
  animations: [
    trigger("indicatorRotate", [
      state("collapsed", style({ transform: "rotate(0deg)" })),
      state("expanded", style({ transform: "rotate(180deg)" })),
      transition(
        "expanded <=> collapsed",
        animate("225ms cubic-bezier(0.4,0.0,0.2,1)")
      ),
    ]),
  ],
})
export class MenuListComponent implements OnInit {
  expanded: boolean;

  @Input() item: MenuDTO;
  @Input() depth: number;

  constructor(public router: Router) {}

  ngOnInit(): void {
    if (this.depth === undefined) {
      this.depth = 0;
    }
    this.checkIfCurrentSubOptionOpened();
  }

  checkIfCurrentSubOptionOpened() {
    if (this.expanded || !this.item.subMenus) {
      return;
    }

    this.expanded = !!this.item.subMenus.find(({ path }) => this.router.url.startsWith(path));
  }

  onItemSelected(item: MenuDTO) {
    if (item.subMenus && item.subMenus.length) {
      this.expanded = !this.expanded;
    }
  }
}
